// Copyright (c) MobiFactory. All rights reserved.
// This source code is the property of MobiFactory. It is exclusively available to customers who have a valid user license.
// See LICENSE.txt file in the project root for full license information.

import backend from "../backend";

export default {
  /**
   * Gets the license of the connected user
   * @returns {Promise<object>} User license
   */
  getMobiCrmLicense() {
    return backend.get("/licenses/mobicrm");
  },
};
